module.exports = __webpack_public_path__ + "img/313.4eef0699.jpg";